import { StrictMode, Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import {
  getBrand,
  applyBrandToDocument
} from "./branding";

import "./index.css";
const App = lazy(() => import("./App.jsx"));
import Recover from "./components/Recover.jsx";
import Login from "./components/Login.jsx";
const CompletedExam = lazy(() => import("./components/CompletedExam.jsx"));
import ExamLoader from "./components/ExamLoader.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";

const brand = getBrand();

import TeacherPortal from "./teacher/TeacherPortal.jsx";

const ExamEditorApp = lazy(() => import("./editor/ExamEditorApp.jsx"));

applyBrandToDocument(brand);

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <BrowserRouter>
      <Suspense fallback={<ExamLoader />}><Routes>
        <Route path="/teachers/*" element={<TeacherPortal />} />

        {/* Login */}
        <Route path="/" element={<Login />} />
        <Route path="/recover" element={<Recover/>} />
        <Route path="/login" element={<Login />} />
        <Route path="/exams" element={<Login />} />

        {/* PRACTICE — PUBLIC */}
        <Route
          path="/practice/:examId"
          element={<App practiceMode />}
        />

        {/* CHAIR - PRIVATE */}
        <Route
          path="/chair/private/:examId"
          element={<App chairMode />}
        />

        {/* REAL EXAM — PROTECTED */}
        <Route
          path="/exam/:examId"
          element={
            <ProtectedRoute>
              <App />
            </ProtectedRoute>
          }
        />

        {/* DEV MODE */}
        <Route
          path="/dev/:examId"
          element={
            <App devMode/>
          }
        />

        {/* EXAM EDITOR — protected by server-side EXAM_EDITOR_TOKEN */}
        <Route path="/admin/exams" element={<Suspense fallback={<div>Loading editor…</div>}><ExamEditorApp /></Suspense>} />
        <Route path="/admin/exams/:examId" element={<Suspense fallback={<div>Loading editor…</div>}><ExamEditorApp /></Suspense>} />

        {/* REVIEW — PUBLIC */}
        <Route
          path="/submissions/:submissionId"
          element={<CompletedExam />}
        />

        <Route path="*" element={<div>Not found</div>} />
      </Routes></Suspense>

    </BrowserRouter>
  </StrictMode>
);

